import React, { useEffect, useState } from 'react';
import { Clock, MapPin, Phone, Star, Award, Users, Dumbbell, Heart, ArrowRight, Zap, Target, Activity, ChevronDown } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
  const [activeSection, setActiveSection] = useState('inicio');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['inicio', 'sobre', 'modalidades', 'horarios', 'depoimentos', 'localizacao', 'faq'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  };

  const whatsappLink = "https://wa.me/5554981000046";

  const modalidades = [
    {
      icon: <Zap className="w-12 h-12" />,
      title: "Treino HIIT",
      duration: "30 minutos",
      description: "High Intensity Interval Training - treino de alta intensidade em intervalos curtos que acelera o metabolismo e queima gordura",
      benefits: [
        "Emagrecimento acelerado",
        "Queima de gordura mesmo após o treino",
        "Treino diferente a cada dia",
        "Método estruturado e controlado"
      ],
      location: "Unidade HIIT"
    },
    {
      icon: <Activity className="w-12 h-12" />,
      title: "Treino BURN",
      duration: "30 minutos",
      description: "Focado em queima intensa com monitoramento cardíaco em tempo real via pulseira de frequência",
      benefits: [
        "Elimina mais de 400 calorias por treino",
        "Monitoramento cardíaco em tempo real",
        "Alto gasto calórico",
        "Controle total da intensidade"
      ],
      location: "Unidade HIIT (Ter e Qui)"
    },
    {
      icon: <Target className="w-12 h-12" />,
      title: "Treino Funcional",
      duration: "50min - 1 hora",
      description: "Movimentos naturais integrados com acessórios como Kettlebell, TRX, Wallball, Medicine Ball e FitPulley",
      benefits: [
        "Ganho de força e resistência",
        "Definição e firmeza muscular",
        "Melhora da mobilidade",
        "Resultados com 2x por semana"
      ],
      location: "Unidade Funcional"
    }
  ];

  const faqData = [
    {
      question: "O que é o Vini Salazar Treinamento Funcional?",
      answer: "É um estúdio especializado em treinos funcionais de alta eficiência, focado em emagrecimento, condicionamento físico e resultados reais, com orientação do início ao fim e acompanhamento profissional constante."
    },
    {
      question: "Quanto tempo dura o treino?",
      answer: "Os treinos HIIT e BURN duram em média 30 minutos. O Treino Funcional tem a duração de 50 minutos a 1 hora. É o tempo ideal para treinar com alta intensidade e ter resultado de forma eficiente."
    },
    {
      question: "Preciso já estar em forma para treinar?",
      answer: "Não. Os treinos são adaptados para todos os níveis, desde iniciantes até pessoas mais avançadas. Cada aluno treina respeitando seu próprio ritmo e evolução."
    },
    {
      question: "Qual a diferença entre o estúdio e uma academia tradicional?",
      answer: "No Vini Salazar: você não treina sozinho, tem treino diferente a cada dia, não temos ficha de treino (os professores demonstram e orientam todos os exercícios), tem professor acompanhando o tempo todo, treina em turmas reduzidas, usa monitoramento cardíaco e segue um método estruturado."
    },
    {
      question: "O que é o monitoramento cardíaco?",
      answer: "Durante o treino BURN, o aluno utiliza uma pulseira que mede a frequência cardíaca em tempo real. Isso permite controlar a intensidade, garantir segurança e maximizar os resultados."
    },
    {
      question: "Dá pra emagrecer mesmo treinando só 30 minutos?",
      answer: "Sim. O treino é intenso, controlado e eficiente, mantendo o corpo na zona ideal de queima de gordura, inclusive após o treino. Já tivemos mais de 500 pessoas com ótimos resultados que comprovam que nosso método funciona."
    },
    {
      question: "Quantas vezes por semana posso treinar?",
      answer: "Depende do plano escolhido. Normalmente os alunos treinam de 2 a 5 vezes por semana, conforme objetivo e disponibilidade."
    },
    {
      question: "O treino é seguro?",
      answer: "Sim. Todos os treinos são acompanhados por professores, com correção de movimento, controle de intensidade e adaptação individual."
    },
    {
      question: "Preciso marcar horário?",
      answer: "Sim. Trabalhamos com agendamento através do nosso aplicativo, garantindo turmas organizadas, atenção total e melhor experiência para o aluno."
    },
    {
      question: "Vocês oferecem aula experimental?",
      answer: "Sim, oferecemos aula experimental!"
    },
    {
      question: "Em quanto tempo começo a ver resultados?",
      answer: "Isso varia de pessoa para pessoa, mas muitos alunos relatam mais disposição já na primeira semana, mudanças visíveis em poucas semanas e resultados consistentes com frequência e acompanhamento."
    },
    {
      question: "Posso treinar mesmo tendo dor ou limitação?",
      answer: "Sim, desde que informado previamente. O treino é adaptado, respeitando limites e orientações profissionais."
    },
    {
      question: "Quantas pessoas por turma?",
      answer: "Limitamos a 10 pessoas por turma para garantir atendimento personalizado."
    },
    {
      question: "Tem idade mínima ou máxima?",
      answer: "Atendemos a partir de 16 anos, sem limite máximo."
    },
    {
      question: "Precisa trazer algum material?",
      answer: "Apenas roupa confortável e garrafa de água."
    },
    {
      question: "Tem vestiário com chuveiro?",
      answer: "Sim, nas duas unidades temos vestiário completo com espaço para deixar os pertences e chuveiro."
    },
    {
      question: "Tem estacionamento?",
      answer: "Não temos estacionamento próprio. Nossos alunos estacionam na Rua La Salle e Av. Itália e nunca tivemos problemas."
    },
    {
      question: "Quais formas de pagamento vocês aceitam?",
      answer: "Aceitamos Cartão de crédito (parcelamento conforme o plano), PIX (somente para pagamento à vista) e Dinheiro (somente para pagamento à vista)."
    },
    {
      question: "Qual é o maior diferencial do Vini Salazar?",
      answer: "Resultado real com acompanhamento, método e constância. Não vendemos promessa, vendemos processo, entrega e RESULTADO."
    }
  ];

  const testimonials = [
    {
      name: "Dioneia Z.",
      text: "Destaco o cuidado que os profissionais têm ao passar o treino, sempre atentos aos nossos movimentos.",
      rating: 5
    },
    {
      name: "Claudia M.",
      text: "Saindo de uma cirurgia e retomando os exercícios, pude ver bons resultados em um curto espaço de tempo.",
      rating: 5
    },
    {
      name: "Cliente Satisfeito",
      text: "Ótimo ambiente, treinos dinâmicos e professores super atenciosos e competentes.",
      rating: 5
    },
    {
      name: "Aluno Regular",
      text: "Ótimos profissionais, ótima estrutura, e com espaço amplo ao ar livre.",
      rating: 5
    },
    {
      name: "Membro da Equipe",
      text: "Academia alto astral, sempre diversificando os treinos.",
      rating: 5
    }
  ];

  const schedules = {
    hiit: {
      name: "HIIT",
      location: "Rua La Salle, 923, Sala 21, 2º andar - São Pelegrino",
      days: [
        { day: "Segunda, Quarta e Sexta", times: ["06:30 - 09:00", "11:00 - 13:00", "16:30 - 20:00"] },
        { day: "Terça e Quinta", times: ["07:00 - 09:00", "11:00 - 12:30", "16:30 - 20:00"] },
        { day: "Seg/Qua/Qui", times: ["20:00"] }
      ]
    },
    funcional: {
      name: "Funcional",
      location: "Rua La Salle x Av. Itália, 235, andar superior - São Pelegrino",
      days: [
        { day: "Segunda", times: ["07:00 - 08:30", "16:00 - 20:00"] },
        { day: "Terça a Sexta", times: ["06:30 - 10:00", "16:00 - 20:00"] }
      ]
    }
  };

  const benefits = [
    {
      icon: <Users className="w-8 h-8" />,
      title: "Turmas Reduzidas",
      description: "Máximo 10 alunos por turma para atendimento personalizado"
    },
    {
      icon: <Activity className="w-8 h-8" />,
      title: "Monitoramento Cardíaco",
      description: "Pulseira em tempo real para controle total da intensidade"
    },
    {
      icon: <Award className="w-8 h-8" />,
      title: "+500 Resultados",
      description: "Mais de 500 alunos transformados com nosso método"
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: "Acompanhamento Total",
      description: "Professor presente do início ao fim, sem treino sozinho"
    }
  ];

  const images = [
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/6qoysy48_WhatsApp%20Image%202026-03-29%20at%2016.04.47%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/d9h8kcyw_WhatsApp%20Image%202026-03-29%20at%2016.04.47%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/v0f30t5g_WhatsApp%20Image%202026-03-29%20at%2016.04.47%20%283%29.jpeg",
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/ratoet0j_WhatsApp%20Image%202026-03-29%20at%2016.04.47.jpeg"
  ];

  const newImages = [
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/l4uwhpp8_WhatsApp%20Image%202026-03-29%20at%2016.55.39%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/xyiyq6ru_WhatsApp%20Image%202026-03-29%20at%2016.55.39%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/28rbor9t_WhatsApp%20Image%202026-03-29%20at%2016.59.13%20%284%29.jpeg",
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/s7zy2qnv_WhatsApp%20Image%202026-03-29%20at%2016.59.13%20%285%29.jpeg",
    "https://customer-assets.emergentagent.com/job_funcional-sul/artifacts/z7o61gjq_WhatsApp%20Image%202026-03-29%20at%2016.59.13%20%286%29.jpeg"
  ];

  return (
    <div className="home-container">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <div className="logo">
            <Dumbbell className="w-8 h-8" />
            <span className="logo-text">Vini Salazar</span>
          </div>
          <nav className="nav-menu">
            <button 
              onClick={() => scrollToSection('inicio')}
              className={activeSection === 'inicio' ? 'nav-link active' : 'nav-link'}
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('sobre')}
              className={activeSection === 'sobre' ? 'nav-link active' : 'nav-link'}
            >
              Sobre
            </button>
            <button 
              onClick={() => scrollToSection('modalidades')}
              className={activeSection === 'modalidades' ? 'nav-link active' : 'nav-link'}
            >
              Modalidades
            </button>
            <button 
              onClick={() => scrollToSection('horarios')}
              className={activeSection === 'horarios' ? 'nav-link active' : 'nav-link'}
            >
              Horários
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className={activeSection === 'faq' ? 'nav-link active' : 'nav-link'}
            >
              FAQ
            </button>
          </nav>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
            <Button className="cta-button-header">
              <Phone className="w-4 h-4" />
              Contato
            </Button>
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section id="inicio" className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text">
            <div className="rating-badge">
              <Star className="w-5 h-5 fill-current" />
              <span>5,0 • 52 avaliações no Google</span>
            </div>
            <h1 className="hero-title">
              Treinos de 30 minutos a 1 hora que mudam vidas
            </h1>
            <p className="hero-subtitle">
              HIIT, BURN e Funcional em Caxias do Sul com +500 resultados comprovados, monitoramento cardíaco e acompanhamento profissional constante
            </p>
            <div className="hero-buttons">
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                <Button className="cta-button-primary">
                  Fale com a gente no WhatsApp
                  <ArrowRight className="w-5 h-5" />
                </Button>
              </a>
              <Button 
                onClick={() => scrollToSection('sobre')} 
                className="cta-button-secondary"
              >
                Conheça nossa estrutura
              </Button>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src={images[0]} 
              alt="Vini Salazar Treinamento Funcional"
              className="main-hero-img"
            />
          </div>
        </div>
      </section>

      {/* Sobre Section */}
      <section id="sobre" className="section sobre-section">
        <div className="container">
          <div className="section-header">
            <Award className="w-12 h-12 section-icon" />
            <h2 className="section-title">Sobre Nós</h2>
            <p className="section-subtitle">
              Mais de 10 anos transformando vidas através do treinamento funcional
            </p>
          </div>

          <div className="sobre-content">
            <div className="sobre-text">
              <h3 className="sobre-heading">Nossa Missão</h3>
              <p className="sobre-description">
                Ajudar pessoas que não gostam de academia convencional a <strong>emagrecer, ganhar energia, melhorar a saúde e a autoestima</strong>, através de treinos inteligentes, curtos e altamente eficientes, respeitando o nível e a realidade de cada aluno.
              </p>
              
              <h3 className="sobre-heading">Nosso Diferencial</h3>
              <p className="sobre-description">
                Com <strong>mais de 10 anos de mercado</strong>, nos destacamos pelo acompanhamento próximo dos professores e atenção dedicada aos movimentos de cada aluno. Temos <strong>+500 alunos transformados</strong> com resultados comprovados.
              </p>
              
              <p className="sobre-description">
                Aqui você não treina sozinho. Cada sessão é acompanhada do início ao fim, com <strong>turmas limitadas a 10 pessoas</strong>, garantindo atenção personalizada e segurança em cada movimento.
              </p>
              
              <div className="sobre-highlights">
                <div className="highlight-item">
                  <Award className="w-6 h-6" />
                  <span>Método validado</span>
                </div>
                <div className="highlight-item">
                  <Users className="w-6 h-6" />
                  <span>Turmas reduzidas</span>
                </div>
                <div className="highlight-item">
                  <Activity className="w-6 h-6" />
                  <span>Monitoramento cardíaco</span>
                </div>
                <div className="highlight-item">
                  <Heart className="w-6 h-6" />
                  <span>Vestiário completo</span>
                </div>
              </div>
            </div>

            <div className="gallery-grid">
              {images.slice(1).map((img, index) => (
                <div key={index} className="gallery-item">
                  <img src={img} alt={`Espaço ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          {/* Nova Galeria de Alunos e Resultados */}
          <div className="results-gallery-section">
            <h3 className="results-gallery-title">Nossos Alunos e Resultados</h3>
            <div className="results-gallery-grid">
              {newImages.map((img, index) => (
                <div key={index} className="results-gallery-item">
                  <img src={img} alt={`Alunos e resultados ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <Card key={index} className="benefit-card">
                <CardContent className="benefit-content">
                  <div className="benefit-icon">{benefit.icon}</div>
                  <h3 className="benefit-title">{benefit.title}</h3>
                  <p className="benefit-description">{benefit.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Modalidades Section */}
      <section id="modalidades" className="section modalidades-section">
        <div className="container">
          <div className="section-header">
            <Dumbbell className="w-12 h-12 section-icon" />
            <h2 className="section-title">Nossas Modalidades</h2>
            <p className="section-subtitle">
              Escolha o treino ideal para seu objetivo e rotina
            </p>
          </div>

          <div className="modalidades-grid">
            {modalidades.map((modalidade, index) => (
              <Card key={index} className="modalidade-card">
                <CardContent className="modalidade-content">
                  <div className="modalidade-icon">{modalidade.icon}</div>
                  <h3 className="modalidade-title">{modalidade.title}</h3>
                  <div className="modalidade-duration">{modalidade.duration}</div>
                  <p className="modalidade-description">{modalidade.description}</p>
                  <div className="modalidade-benefits">
                    {modalidade.benefits.map((benefit, idx) => (
                      <div key={idx} className="benefit-item">
                        <Star className="w-4 h-4 benefit-star" />
                        <span>{benefit}</span>
                      </div>
                    ))}
                  </div>
                  <div className="modalidade-location">
                    <MapPin className="w-4 h-4" />
                    <span>{modalidade.location}</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="modalidades-cta">
            <p className="modalidades-cta-text">
              Todas as modalidades incluem acompanhamento profissional do início ao fim
            </p>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button className="cta-button-primary">
                Agende sua aula experimental
                <ArrowRight className="w-5 h-5" />
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Horários Section */}
      <section id="horarios" className="section horarios-section">
        <div className="container">
          <div className="section-header">
            <Clock className="w-12 h-12 section-icon" />
            <h2 className="section-title">Horários das Aulas</h2>
            <p className="section-subtitle">
              Duas unidades em Caxias do Sul com horários flexíveis
            </p>
          </div>

          {/* Unidade HIIT */}
          <div className="unidade-section">
            <h3 className="unidade-title">
              <Zap className="w-6 h-6" />
              Unidade HIIT & BURN
            </h3>
            <p className="unidade-location">
              <MapPin className="w-5 h-5" />
              {schedules.hiit.location}
            </p>
            <div className="horarios-grid">
              {schedules.hiit.days.map((schedule, index) => (
                <Card key={index} className="horario-card">
                  <CardContent className="horario-content">
                    <h4 className="horario-day">{schedule.day}</h4>
                    <div className="horario-times">
                      {schedule.times.map((time, idx) => (
                        <div key={idx} className="time-badge">
                          <Clock className="w-4 h-4" />
                          <span>{time}</span>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Unidade Funcional */}
          <div className="unidade-section">
            <h3 className="unidade-title">
              <Target className="w-6 h-6" />
              Unidade Treino Funcional
            </h3>
            <p className="unidade-location">
              <MapPin className="w-5 h-5" />
              {schedules.funcional.location}
            </p>
            <div className="horarios-grid">
              {schedules.funcional.days.map((schedule, index) => (
                <Card key={index} className="horario-card">
                  <CardContent className="horario-content">
                    <h4 className="horario-day">{schedule.day}</h4>
                    <div className="horario-times">
                      {schedule.times.map((time, idx) => (
                        <div key={idx} className="time-badge">
                          <Clock className="w-4 h-4" />
                          <span>{time}</span>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          <div className="horarios-cta">
            <p className="horarios-cta-text">
              Treinos com duração de 30 minutos (HIIT/BURN) e 50min-1h (Funcional)
            </p>
            <p className="horarios-info">
              Atendimento: Segunda a sexta, 9h às 12h e 14h às 18h
            </p>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button className="cta-button-primary">
                Consulte disponibilidade
                <ArrowRight className="w-5 h-5" />
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Depoimentos Section */}
      <section id="depoimentos" className="section depoimentos-section">
        <div className="container">
          <div className="section-header">
            <Star className="w-12 h-12 section-icon" />
            <h2 className="section-title">O Que Dizem Nossos Alunos</h2>
            <p className="section-subtitle">
              Avaliação 5,0 no Google com 52 avaliações
            </p>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <Card key={index} className="testimonial-card">
                <CardContent className="testimonial-content">
                  <div className="stars">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-current star-icon" />
                    ))}
                  </div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <p className="testimonial-author">— {testimonial.name}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="section faq-section">
        <div className="container">
          <div className="section-header">
            <Award className="w-12 h-12 section-icon" />
            <h2 className="section-title">Perguntas Frequentes</h2>
            <p className="section-subtitle">
              Tudo o que você precisa saber antes de começar
            </p>
          </div>

          <div className="faq-container">
            <Accordion type="single" collapsible className="faq-accordion">
              {faqData.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="faq-item">
                  <AccordionTrigger className="faq-question">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="faq-answer">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          <div className="faq-cta">
            <p className="faq-cta-text">
              Ainda tem dúvidas? Fale com nossa equipe!
            </p>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button className="cta-button-primary">
                Falar no WhatsApp
                <ArrowRight className="w-5 h-5" />
              </Button>
            </a>
          </div>
        </div>
      </section>
      
      {/* Localização Section */}
      <section id="localizacao" className="section localizacao-section">
        <div className="container">
          <div className="section-header">
            <MapPin className="w-12 h-12 section-icon" />
            <h2 className="section-title">Nossas Unidades</h2>
            <p className="section-subtitle">
              Duas unidades em São Pelegrino, Caxias do Sul
            </p>
          </div>

          {/* Unidade HIIT */}
          <div className="location-unit">
            <h3 className="location-unit-title">
              <Zap className="w-6 h-6" />
              Unidade HIIT & BURN
            </h3>
            <div className="localizacao-content">
              <div className="localizacao-info-single">
                <Card className="info-card-full">
                  <CardContent className="info-content">
                    <MapPin className="w-8 h-8 info-icon" />
                    <div>
                      <h4 className="info-title">Endereço</h4>
                      <p className="info-text">
                        Rua La Salle, 923, Sala 21, 2º andar<br />
                        Bairro São Pelegrino<br />
                        Caxias do Sul - RS<br />
                        CEP: 95020-100<br />
                        <small className="location-ref">Próximo ao Restaurante Danúbio</small>
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>

              <div className="map-container">
                <iframe
                  title="Unidade HIIT"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3483.1!2d-51.179!3d-29.164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjnCsDA5JzUwLjQiUyA1McKwMTAnNDQuNCJX!5e0!3m2!1spt-BR!2sbr!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Unidade Funcional */}
          <div className="location-unit">
            <h3 className="location-unit-title">
              <Target className="w-6 h-6" />
              Unidade Treino Funcional
            </h3>
            <div className="localizacao-content">
              <div className="localizacao-info-single">
                <Card className="info-card-full">
                  <CardContent className="info-content">
                    <MapPin className="w-8 h-8 info-icon" />
                    <div>
                      <h4 className="info-title">Endereço</h4>
                      <p className="info-text">
                        Rua La Salle x Av. Itália, 235<br />
                        Andar superior<br />
                        Bairro São Pelegrino<br />
                        Caxias do Sul - RS<br />
                        CEP: 95010-040<br />
                        <small className="location-ref">Em cima do Mercado Itália, entrada pela Rua La Salle</small>
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>

              <div className="map-container">
                <iframe
                  title="Unidade Funcional"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3483.1!2d-51.179!3d-29.164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjnCsDA5JzUwLjQiUyA1McKwMTAnNDQuNCJX!5e0!3m2!1spt-BR!2sbr!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Info Cards */}
          <div className="contact-info-grid">
            <Card className="info-card">
              <CardContent className="info-content">
                <Phone className="w-8 h-8 info-icon" />
                <div>
                  <h4 className="info-title">Telefone / WhatsApp</h4>
                  <p className="info-text">
                    (54) 98100-0046
                  </p>
                  <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                    <Button className="cta-button-small">
                      Enviar mensagem
                    </Button>
                  </a>
                </div>
              </CardContent>
            </Card>

            <Card className="info-card">
              <CardContent className="info-content">
                <Clock className="w-8 h-8 info-icon" />
                <div>
                  <h4 className="info-title">Atendimento</h4>
                  <p className="info-text">
                    Segunda a Sexta<br />
                    09:00 às 12:00<br />
                    14:00 às 18:00
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="info-card">
              <CardContent className="info-content">
                <Heart className="w-8 h-8 info-icon" />
                <div>
                  <h4 className="info-title">Facilidades</h4>
                  <p className="info-text">
                    • Vestiário com chuveiro<br />
                    • Estacionamento na rua<br />
                    • App de agendamento<br />
                    • Turmas até 10 pessoas
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Final Section */}
      <section className="section cta-final-section">
        <div className="container">
          <div className="cta-final-content">
            <h2 className="cta-final-title">
              Pronto para transformar sua vida?
            </h2>
            <p className="cta-final-text">
              Junte-se a mais de 500 alunos que já alcançaram resultados reais com nosso método validado de treinamento funcional
            </p>
            <div className="cta-final-features">
              <div className="cta-feature">
                <Activity className="w-6 h-6" />
                <span>Monitoramento cardíaco</span>
              </div>
              <div className="cta-feature">
                <Users className="w-6 h-6" />
                <span>Turmas até 10 pessoas</span>
              </div>
              <div className="cta-feature">
                <Award className="w-6 h-6" />
                <span>Método comprovado</span>
              </div>
            </div>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button className="cta-button-final">
                Começar agora pelo WhatsApp
                <ArrowRight className="w-6 h-6" />
              </Button>
            </a>
            <p className="cta-payment">
              💳 Aceitamos Cartão, PIX e Dinheiro
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <Dumbbell className="w-8 h-8" />
              <span className="footer-logo-text">Vini Salazar Treinamento Funcional</span>
              <p className="footer-slogan">Resultado real com acompanhamento</p>
            </div>
            <div className="footer-info">
              <h4 className="footer-section-title">Unidades</h4>
              <p>HIIT & BURN: Rua La Salle, 923 - Sala 21</p>
              <p>Funcional: Rua La Salle x Av. Itália, 235</p>
              <p>(54) 98100-0046</p>
            </div>
            <div className="footer-rating">
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-current star-icon" />
                ))}
              </div>
              <p>5,0 • 52 avaliações no Google</p>
              <p className="footer-results">+500 alunos transformados</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2026 Vini Salazar Treinamento Funcional. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <WhatsAppButton phoneNumber="5554981000046" />
    </div>
  );
};

export default Home;
